import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { ParallaxProvider } from 'react-skrollr';
import { withRedux } from '../../hoc';
import { switchLanguage } from '../../actions/language';
import { Footer } from '../../components';
import Section1 from './Section1';
import Mission from './Mission';
import Developer from './Developer';

const mapStateToProps = state => {
  return {
    ...state
  };
};

const actionToProps = {
  switchLanguage
};

@withRedux(mapStateToProps, actionToProps)
export default class index extends Component {
  constructor(props) {
    super(props);
    this.headerRef = React.createRef();
  }
  componentDidMount() {
    this.setLanguage(this.props.match.params.language);
  }
  componentDidUpdate(prevProps) {
    const currentLanguage = prevProps.match.params.language;
    const nextLanguage = this.props.match.params.language;
    if (currentLanguage !== nextLanguage) {
      this.setLanguage(nextLanguage);
    }
  }
  setLanguage = language => {
    this.props.actions.switchLanguage(language);
  };
  render() {
    return (
      <ParallaxProvider
        init={{
          smoothScrollingDuration: 0,
          smoothScrolling: true,
          forceHeight: false
        }}
      >
        <Fragment>
          <Helmet>
            <title>Laguna</title>
          </Helmet>
          <Section1 />
          <Mission />
          <Developer/>
          <Fragment>
            <Footer />
          </Fragment>
        </Fragment>
      </ParallaxProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AboutUs/index.js